<template>
  <div class="text-container">
    <div class="text" v-html="parsedContent" />
  </div>
</template>

<script>
import bbcodeHTML from 'marketplace-front-core/config/bbcodeHTML-editor'

export default {
  props: {
    content: {
      type: Object,
      default: null
    }
  },

  computed: {
    parsedContent () {
      if (!this.content || !this.content.value) {
        return ''
      }
      return bbcodeHTML(this.content.value)
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(pill) {
  padding: 8px 16px;
  border-radius: 22px;
  display: inline-block !important;
  // background: $primary;

  &.red-light {
    color:  #D20311;
    background-color: #FCE5E6;
  }

  &.blue-light {
    color: #0066CC;
    background-color: #CED9EF;
  }

  &.green-light {
    color: #099C8B;
    background-color: #C8EDEC;
  }

  &.purple-light {
    color:  #8324E3;
    background-color: #E0D0F9;
  }
}

:deep(.text-container) {
  position: relative;
}

:deep(.textaligncenter) {
  text-align: center;
}

:deep(.center) {
  text-align: center;
}

:deep(.textalignright) {
  text-align: right;
}

:deep(.right) {
  text-align: right;
}

:deep(.textalignleft) {
  text-align: left;
}

:deep(.left) {
  text-align: left;
}

:deep(.textalignjustify) {
  text-align: justify !important;
}

:deep(.justify) {
  text-align: justify !important;
}

:deep(.text) {
  position: relative;
  h1,
  h2,
  h3,
  h4,
  h5 {
    hyphens: auto;
    overflow-wrap: break-word;
    font-weight: 600;
    margin: 24px 0;
    line-height: 1.35;
    color: inherit;
  }

  h1 {
    font-size: 32px;

    @include mobile {
      font-size: 24px;
    }
  }

  h2 {
    font-size: 32px;

    @include mobile {
      font-size: 24px;
    }
  }

  h3 {
    font-size: 24px;

    @include mobile {
      font-size: 20px;
    }
  }

  h4 {
    font-size: 20px;

    @include mobile {
      font-size: 18px;
    }
  }

  h5 {
    font-size: 16px;

    @include mobile {
      font-size: 14px;
    }
  }

  h6 {
    font-size: 12px;

  }

  p {
    font-size: 16px;
    font-weight: 400;
    margin: 12px 0;
    hyphens: auto;
    overflow-wrap: break-word;
  }

  h1 {
    .texticon {
      width: 40px;
      height: 40px;
    }
  }

  .stars+h2 {
    margin-top: 0;
  }

  .texticon {
    // margin-left: 8px;
    position: relative;
    top: 3px;
  }

  h2 {
    .texticon {
      width: 32px;
      height: 32px;
    }
  }

  h3 {
    .texticon {
      width: 24px;
      height: 24px;
    }
  }

  h4 {
    .texticon {
      width: 20px;
      height: 20px;
    }
  }

  h5,
  p {
    .texticon {
      width: 16px;
      height: 16px;
    }
  }

  ul,
  ol {
    margin: 24px 0;
  }

  ol {
    list-style-position: inside;
  }

  ul {
    &.checklistmedium {
      li {
        font-size: 20px;
        font-weight: 400;
        padding-left: 10px;
        position: relative;
        list-style: none;
        margin-left: 38px;
        list-style-position: outside;
        p{
        margin: 0 !important;
        display: inline !important;
      }
         .texticon {
      width: 20px;
      height: 20px;
      }

        @include mobile {
          font-size: 18px;
          // padding-left: 0;
        }

        &:not(:last-child) {
          margin-bottom: 16px;

          @include mobile {
            margin-bottom: 12px;
          }
        }

        &::before {
          content: "";
          background-image: url('../../../assets/generate-icons/icons/check-red.svg');
          background-position: left 0 top 0;
          background-repeat: no-repeat;
          margin-left: -33px;
          width: 24px;
          height: 24px;
          display: inline-block;
          margin-right: 10px;
          transform: translateY(4px);
        }

        @include mobile {
          margin-left: 24px;
        }
      }
    }
  }
  ol.numberlist{
    margin-left: 20px;
      .texticon {
      width: 16px;
      height: 16px;
    }
  }

  ul.checklist {
    font-size: 16px;
    list-style-type: none;
    margin-left: 30px;

    @include mobile {
      margin-left: 24px;
    }

    .texticon {
      width: 16px;
      height: 16px;
    }

    li {
      // display: flex;
      // align-items: center;
      position: relative;
      padding-left: 8px;
      p, h1, h2, h3{
        margin: 0 !important;
        display: inline !important;
      }

      &:not(:last-child) {
        margin-bottom: 8px;
      }

      &::before {
        content: "";
        background-image: url('../../../assets/generate-icons/icons/check-red.svg');
        background-position: left;
        background-size: contain;
        background-repeat: no-repeat;
        margin-left: -23px;
        width: 16px;
        height: 16px;
        display: inline-block;
        margin-right: 8px;
      }
    }
  }

  .bulletlist {
    li {
      font-size: 16px;
      font-weight: 400;
      list-style-type: disc;
      position: relative;
      list-style-position: outside;
      margin-left: 48px;

      @include mobile {
        margin-left: 18px;
      }

      // margin: 24px 0 24px 24px;
    }
      .texticon {
      width: 16px;
      height: 16px;
    }
  }

  blockquote {
    border: none;
    border-radius: 10px;
    padding: 24px;

    & > :first-child {
      margin-top: 0px !important;
    }

    & > :last-child {
      margin-bottom: 0px !important;
    }
  }

  b {
    font-weight: 600;
    margin: 0;
  }

  span {
    color: #06c;
  }
}
</style>
